var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestOtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 17.5,
    viewBox: "0 0 21.5 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "password-minimalistic-svgrepo-com",
    transform: "translate(-1.25 -3.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9825",
    "data-name": "Path 9825",
    d: "M2,12C2,8.229,2,6.343,3.172,5.172S6.229,4,10,4h4c3.771,0,5.657,0,6.828,1.172S22,8.229,22,12s0,5.657-1.172,6.828S17.771,20,14,20H10c-3.771,0-5.657,0-6.828-1.172S2,15.771,2,12Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9826",
    "data-name": "Path 9826",
    d: "M9,12a1,1,0,1,1-1-1A1,1,0,0,1,9,12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9827",
    "data-name": "Path 9827",
    d: "M13,12a1,1,0,1,1-1-1A1,1,0,0,1,13,12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9828",
    "data-name": "Path 9828",
    d: "M17,12a1,1,0,1,1-1-1A1,1,0,0,1,17,12Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestOtp);
export default __webpack_public_path__ + "static/media/request-otp.78a07c5568fa09a88deed4d950232bdf.svg";
export { ForwardRef as ReactComponent };